import { TextMaterialCategory } from '@@partner:types:app'
import { gql, useQuery } from '@apollo/client'
import { SHORTCUT_TEXT_MATERIAL_TYPES_FIELDS } from '../textMaterialShortcut'



export interface AllTextMaterialTypes {
  allTextMaterialTypes: TextMaterialCategory[]
}

export const GQL_QUERY_ALL_TEXT_MATERIAL_TYPES = gql`
  query {
    allTextMaterialTypes {
      ${SHORTCUT_TEXT_MATERIAL_TYPES_FIELDS}
    }
  }
`

export const useFetchAllTextMaterialTypes = () => 
  useQuery<AllTextMaterialTypes>(GQL_QUERY_ALL_TEXT_MATERIAL_TYPES)